module.exports = __webpack_public_path__ + "static/cateau3-0417e27d7f1a5c09ec971c080cbd6ec5.png";